import { useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace('#', '?'));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      window.location.href = '/';
      return;
    }

    const exchangeSession = async () => {
      try {
        const res = await fetch(`${API_URL}/api/auth/google/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (res.ok) {
          const data = await res.json();
          if (data.user && data.session_token) {
            // Write DIRECTLY to localStorage (bypass React state race condition)
            localStorage.setItem('fq_auth_user', JSON.stringify(data.user));
            localStorage.setItem('fq_auth_token', data.session_token);
            // Mark login timestamp to prevent premature cleanup
            localStorage.setItem('fq_auth_ts', Date.now().toString());
          }
          // Force full page reload — NOT React Router navigate
          // This ensures checkAuth reads fresh localStorage on the new page
          window.location.href = '/profile';
        } else {
          window.location.href = '/';
        }
      } catch {
        window.location.href = '/';
      }
    };

    exchangeSession();
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-[#F4C430] via-[#FF8C42] to-[#FF6B35]">
      <div className="text-center text-white">
        <div className="w-12 h-12 border-4 border-white/30 border-t-white rounded-full animate-spin mx-auto mb-4" />
        <p className="text-lg font-medium">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
